import { Button, Stack } from '@mui/material'
import { CRAFT_TYPES } from '@/types/constants'
import type { CraftType } from '@/types'

interface Props {
  selected: CraftType | null
  onChange: (craft: CraftType) => void
}

export function CraftTabBar({ selected, onChange }: Props) {
  return (
    <Stack direction="row" spacing={0.5} flexWrap="wrap">
      {CRAFT_TYPES.map(({ value, label }) => (
        <Button
          key={value}
          size="small"
          variant={selected === value ? 'contained' : 'text'}
          color={selected === value ? 'warning' : 'inherit'}
          onClick={() => onChange(value)}
          sx={{ minWidth: 'auto', fontWeight: selected === value ? 700 : 400 }}
        >
          {label}
        </Button>
      ))}
    </Stack>
  )
}
